import React, { useState, useEffect } from 'react';

const Toast = ({ message, type = 'success', show, onClose }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div className={`toast show position-fixed top-0 end-0 m-3`} style={{ zIndex: 1050 }}>
      <div className={`toast-header bg-${type === 'error' ? 'danger' : 'success'} text-white`}>
        <strong className="me-auto">{type === 'error' ? 'Error' : 'Success'}</strong>
        <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
      </div>
      <div className="toast-body">
        {message}
      </div>
    </div>
  );
};

export default Toast;